import { TermsOfService } from '@/base/domains';

export const termsOfServices: Array<TermsOfService> = [
  {
    id: 'v1',
    body: '# 利用規約(v1)\n\n## インデックス\nテキストテキストテキストテキストテキストテキストテキストテキスト\nテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト\n## インデックス\nテキストテキストテキストテキストテキストテキストテキストテキスト\nテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト\n',
  },
];
